import { render, staticRenderFns } from "./CarlosMunoz.vue?vue&type=template&id=37e9a37e&scoped=true"
import script from "./CarlosMunoz.vue?vue&type=script&lang=js"
export * from "./CarlosMunoz.vue?vue&type=script&lang=js"
import style0 from "./CarlosMunoz.vue?vue&type=style&index=0&id=37e9a37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9a37e",
  null
  
)

export default component.exports